import React, { Fragment,useState, useCallback } from "react";
import { TextField, Dialog, DialogContent, DialogActions, Button, Typography } from "@mui/material";
import axios from "axios";

function PasswordReset(props) {
  const [passwordsDontMatch, setPasswordsDontMatch]=useState(false)
  const sendPasswordReset = useCallback((event) => {
    console.log('sending password reset')
    console.log(event.target.password.value)
    console.log(event.target.confirmPassword.value)
    if(event.target.password.value===event.target.confirmPassword.value){
      console.log('passwords match')
      let data={password:event.target.password.value,
                userID:props.match.params.id,
                userToken:props.match.params.token}
      console.log('password reset data...')
      console.log(data)
      axios.post("/api/users/reset-password", data).then((res) => {
        console.log('response from save answers api..')
        console.log(res) 
        window.location.href = "/login";
      })
    }
    else{
      setPasswordsDontMatch(true)
    }
  })

  return (
    <Fragment >
      

      <form onSubmit={(e) => {
          e.preventDefault();
          sendPasswordReset(e);
        }}
            style={{height:'100vh', alignContent:'center',width:'100vw',
                   alignItems:'center',alignSelf:'center',display:'grid',
                   position:'relative'}}>
      <TextField style={{width:'40vw',margin:'auto',paddingBottom:'3em'}}
              variant="outlined"
              margin="normal"
              required
              fullWidth
              label="New Password"
              autoFocus
              autoComplete="off"
              type="password"
              name='password'
              FormHelperTextProps={{ error: true }}
            />
     <TextField style={{width:'40vw',margin:'auto'}}
              variant="outlined"
              margin="normal"
              required
              fullWidth
              name='confirmPassword'
              label="ConfirmNew Password"
              autoFocus
              autoComplete="off"
              type="password"
              error={passwordsDontMatch}
              helperText={
                passwordsDontMatch &&
                "Passwords don't match."
              }
              FormHelperTextProps={{ passwordsDontMatch: true }}
            />
        <Button
            type="submit"
            variant="contained"
            color="secondary"
            style={{width:'20vw',margin:'auto',marginTop:'4em'}}
          >
            Reset password
      
          </Button>
      </form>
 
      
    </Fragment>
  );
}


export default PasswordReset;
